import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { uiState} from './uiReducer';
import { uiItems} from './uiItemsReducer';
import { userInfo } from "./userReducer";
import { appSettings} from './appSettingsReducer';

export default combineReducers({ 
      routing: routerReducer,
      oidc: userInfo,
      uiState,
      uiItems,
      appSettings,
      }
);


